export const DISPLAY_FORMAT = 'L';
export const ISO_FORMAT = 'YYYY-MM-DD';
export const ISO_MONTH_FORMAT = 'YYYY-MM';

export const START_DATE = 'startDate';
export const END_DATE = 'endDate';

export const HORIZONTAL_ORIENTATION = 'horizontal';
export const VERTICAL_ORIENTATION = 'vertical';
export const VERTICAL_SCROLLABLE = 'verticalScrollable';

export const ICON_BEFORE_POSITION = 'before';
export const ICON_AFTER_POSITION = 'after';

export const INFO_POSITION_TOP = 'top';
export const INFO_POSITION_BOTTOM = 'bottom';
export const INFO_POSITION_BEFORE = 'before';
export const INFO_POSITION_AFTER = 'after';

export const ANCHOR_LEFT = 'left';
export const ANCHOR_RIGHT = 'right';

export const OPEN_DOWN = 'down';
export const OPEN_UP = 'up';

export const DAY_SIZE = 39;
export const BLOCKED_MODIFIER = 'blocked';
export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];

export const FANG_WIDTH_PX = 20;
export const FANG_HEIGHT_PX = 10;
export const DEFAULT_VERTICAL_SPACING = 22;

export const MODIFIER_KEY_NAMES = new Set(['Shift', 'Control', 'Alt', 'Meta']);
export const OperationalCity = [
    {
        value: 'gurgaon',
        label: 'gurgaon'
    },
    {
        value: 'delhi',
        label: 'delhi'
    },
    {
        value: 'faridabad',
        label: 'faridabad'
    },
    {
        value: 'ghaziabad',
        label: 'ghaziabad'
    },
    {
        value: 'noida',
        label: 'noida'
    },
]

export const gurgaonSubareas = [
    { label: "MG Road", value: "mg-road" },
    { label: "Sector 29", value: "sector-29" },
    { label: "NH-8", value: "nh-8" },
    { label: "DLF Cyber City", value: "dlf-cyber-city" },
    { label: "Golf Course Road", value: "golf-course-road" },
    { label: "Sohna Road", value: "sohna-road" },
    { label: "Old Gurgaon", value: "old-gurgaon" },
    { label: "Udyog Vihar", value: "udyog-vihar" },
    { label: "Palam Vihar", value: "palam-vihar" },
    { label: "Golf Course Extension Road", value: "golf-course-extension-road" },
    { label: "Anywhere in Gurgaon", value: "anywhere-in-gurgaon" },
    { label: "Manesar/Neemrana", value: "manesar/neemrana" }
  ];

  export const delhiSubareas = [
    { label: "South Delhi", value: "south-delhi" },
    { label: "Central Delhi", value: "central-delhi" },
    { label: "West Delhi", value: "west-delhi" },
    { label: "North Delhi", value: "north-delhi" },
    { label: "East Delhi", value: "east-delhi" }
  ]
  
export const faridabadSubareas = [
    { label: "Surajkund", value: "Surajkund" },
    { label: "NIT", value: "NIT" },
    { label: "Mathura Road", value: "Mathura Road" },
    { label: "Sector 12", value: "Sector 12" },
    { label: "Sector 16", value: "Sector 16" },
    { label: "Sector 10", value: "Sector 10" },
    { label: "Sector 41", value: "Sector 41" },
    { label: "Sector 11", value: "Sector 11" },
    { label: "Sector 21", value: "Sector 21" },
    { label: "Sector 31", value: "Sector 31" },
    { label: "Sector 32", value: "Sector 32" },
    { label: "Sector 35", value: "Sector 35" },
    { label: "Sector 37", value: "Sector 37" },
    { label: "Sector 86", value: "Sector 86" },
    { label: "Badkhal", value: "Badkhal" },
    { label: "Ballabhgarh", value: "Ballabhgarh" },
    { label: "Sector 20", value: "Sector 20" },
    { label: "Sector 39", value: "Sector 39" },
    { label: "Sohna Road", value: "Sohna Road" },
    { label: "Sector 89", value: "Sector 89" },
    { label: "sector 36", value: "sector 36" },
    { label: "Sikri Belt", value: "Sikri Belt" },
    { label: "Sec 31", value: "Sec 31" },
    { label: "Tigaon", value: "Tigaon" },
    { label: "Kail Gaon", value: "Kail Gaon" },
    { label: "Ankheer", value: "Ankheer" },
    { label: "Sector 88", value: "Sector 88" },
    { label: "Sikri", value: "Sikri" },
    { label: "Sector 45", value: "Sector 45" },
    { label: "Sector 17", value: "Sector 17" },
    { label: "Sector 7", value: "Sector 7" },
    { label: "Sector 15", value: "Sector 15" },
    { label: "Neelam bata road", value: "Neelam bata road" },
    { label: "Sector 49", value: "Sector 49" },
    { label: "Shooting Range", value: "Shooting Range" },
    { label: "Manger", value: "Manger" },
    { label: "Anywhere in Faridabad", value: "Anywhere in Faridabad" }
  ]
  
export const ghaziabadSubareas = [
    { label: "Indirapuram", value: "Indirapuram" },
    { label: "Raj Nagar", value: "Raj Nagar" },
    { label: "Raj Nagar Extension", value: "Raj Nagar Extension" },
    { label: "Vaishali", value: "Vaishali" },
    { label: "Vasundhara", value: "Vasundhara" },
    { label: "Sahibabad", value: "Sahibabad" },
    { label: "Kaushambi", value: "Kaushambi" },
    { label: "Govindpuram", value: "Govindpuram" },
    { label: "Crossings Republik", value: "Crossings Republik" },
    { label: "Pandav Nagar", value: "Pandav Nagar" },
    { label: "Mohan Nagar", value: "Mohan Nagar" },
    { label: "Kavi Nagar", value: "Kavi Nagar" },
    { label: "Meerut Road", value: "Meerut Road" },
    { label: "Surya Nagar", value: "Surya Nagar" },
    { label: "Ambedkar Road", value: "Ambedkar Road" },
    { label: "Sanjay Nagar", value: "Sanjay Nagar" },
    { label: "Vaishali Metro Station", value: "Vaishali Metro Station" },
    { label: "Naya Ganj", value: "Naya Ganj" },
    { label: "Adhyatmik Nagar", value: "Adhyatmik Nagar" },
    { label: "Muradnagar", value: "Muradnagar" },
    { label: "Shalimar garden", value: "Shalimar garden" },
    { label: "Tyagi Vihar", value: "Tyagi Vihar" },
    { label: "Sector 23", value: "Sector 23" },
    { label: "Anywhere in Ghaziabad", value: "Anywhere in Ghaziabad" }
  ]

  export const goaSubareas = [
    { label: "Panaji", value: "panaji" },
    { label: "Madgaon", value: "madgaon" },
    { label: "North Goa", value: "north-goa" },
    { label: "South Goa", value: "south-goa" }
  ]

  export const jaipurSubareas = [
    { label: "Kukas Delhi Road", value: "kukas-delhi-road" },
    { label: "Ajmer Road", value: "ajmer-road" },
    { label: "Sikar Road", value: "sikar-road" },
    { label: "Tank Road", value: "tank-road" },
    { label: "Mansarovar", value: "mansarovar" },
    { label: "Vaishali Nagar", value: "vaishali-nagar" }
  ]

  export const mumbaiSubareas = [
    { label: "Navi Mumbai", value: "navi-mumbai" },
    { label: "Thane", value: "thane" },
    { label: "Central Suburbs", value: "central-suburbs" },
    { label: "Western Suburbs", value: "western-suburbs" },
    { label: "South Mumbai", value: "south-mumbai" }
  ]

  export const noidaSubareas = [
    { label: "Central Noida", value: "central noida" },
    { label: "Noida Extension", value: "noida extension" },
    { label: "Golf Course", value: "golf-course" },
    { label: "Greater Noida", value: "greater-noida" },
    { label: "Sector 1", value: "sector-1" },
    { label: "Sector 102", value: "sector-102" },
    { label: "Sector 104", value: "sector-104" },
    { label: "Sector 110", value: "sector-110" },
    { label: "Sector 12", value: "sector-12" },
    { label: "Sector 122", value: "sector-122" },
    { label: "Sector 127", value: "sector-127" },
    { label: "Sector 132", value: "sector-132" },
    { label: "Sector 135", value: "sector-135" },
    { label: "Sector 137", value: "sector-137" },
    { label: "Sector 142", value: "sector-142" },
    { label: "Sector 143", value: "sector-143" },
    { label: "Sector 15", value: "sector-15" },
    { label: "Sector 16", value: "sector-16" },
    { label: "Sector 18", value: "sector-18" },
    { label: "Sector 20", value: "sector-20" },
    { label: "Sector 22", value: "sector-22" },
    { label: "Sector 25", value: "sector-25" },
    { label: "Sector 26", value: "sector-26" },
    { label: "Sector 27", value: "sector-27" },
    { label: "Sector 29", value: "sector-29" },
    { label: "Sector 31", value: "sector-31" },
    { label: "Sector 32", value: "sector-32" },
    { label: "Sector 34", value: "sector-34" },
    { label: "Sector 37", value: "sector-37" },
    { label: "Sector 38", value: "sector-38" },
    { label: "Sector 41", value: "sector-41" },
    { label: "Sector 43", value: "sector-43" },
    { label: "Sector 44", value: "sector-44" },
    { label: "Sector 46", value: "sector-46" },
    { label: "Sector 50", value: "sector-50" },
    { label: "Sector 51", value: "sector-51" },
    { label: "Sector 52", value: "sector-52" },
    { label: "Sector 53", value: "sector-53" },
    { label: "Sector 55", value: "sector-55" },
    { label: "Sector 58", value: "sector-58" },
    { label: "Sector 6", value: "sector-6" },
    { label: "Sector 61", value: "sector-61" },
    { label: "Sector 62", value: "sector-62" },
    { label: "Sector 63", value: "sector-63" },
    { label: "Sector 66", value: "sector-66" },
    { label: "Sector 70", value: "sector-70" },
    { label: "Sector 71", value: "sector-71" },
    { label: "Sector 72", value: "sector-72" },
    { label: "Sector 73", value: "sector-73" },
    { label: "Sector 80", value: "sector-80" },
    { label: "Sector 81", value: "sector-81" },
    { label: "anywhere in noida", value: "anywhere in noida" }
  ]

  export const pushkarSubareas = [
    { label: "Nedaliya", value: "nedaliya" },
    { label: "Gurudwara vamdev road", value: "gurudwara vamdev road" },
    { label: "Chawandiya", value: "chawandiya" },
    { label: "Motisar road", value: "motisar road" },
    { label: "Ganahera", value: "ganahera" }
]

  
